import { render, staticRenderFns } from "./Profile.vue?vue&type=template&id=aa059862&scoped=true&"
import script from "./Profile.vue?vue&type=script&lang=js&"
export * from "./Profile.vue?vue&type=script&lang=js&"
import style0 from "./Profile.vue?vue&type=style&index=0&id=aa059862&prod&lang=scss&"
import style1 from "./Profile.vue?vue&type=style&index=1&id=aa059862&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa059862",
  null
  
)

export default component.exports